import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CityInfo } from 'src/app/shared/models/domain/cityInfo';
import { Banner } from '../../shared/models/banner';

@Component({
  selector: 'banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerComponent {
  CUSTOM_BANNER = 'CUSTOM';
  BANNER_POSITION = 'banner-position-';  
  REASONS_TO_BUY_BANNER = 'REASONS_TO_BUY';
  DRAPER_BANNER = 'DRAPER';

  @Input() bannerData: Banner;
  @Input() destinationCity: CityInfo;

  public getBannerType(): string {

    if (this.isReasonsToBuyBanner()) {
      return this.REASONS_TO_BUY_BANNER;
    }
    return this.DRAPER_BANNER;
  }

  private isReasonsToBuyBanner() {
    return this.bannerData.source === this.CUSTOM_BANNER && this.bannerData.subType == this.REASONS_TO_BUY_BANNER;
  } 
  
}
